import type { GolfCourseApiSearchResult, GolfCourseApiCourse } from '@/types/golfCourseApi';

const BASE_URL = 'https://api.golfcourseapi.com/v1';

function getApiKey(): string {
  const key = import.meta.env.VITE_GOLF_COURSE_API_KEY;
  if (!key) {
    console.error('Missing VITE_GOLF_COURSE_API_KEY environment variable');
  }
  return key || '';
}

async function apiFetch<T>(path: string): Promise<T | null> {
  try {
    const res = await fetch(`${BASE_URL}${path}`, {
      headers: {
        Authorization: `Key ${getApiKey()}`,
      },
    });

    if (!res.ok) {
      console.error(`GolfCourseAPI ${path} responded with ${res.status}`);
      return null;
    }

    return (await res.json()) as T;
  } catch (err) {
    console.error(`GolfCourseAPI fetch error for ${path}:`, err);
    return null;
  }
}

/** Search courses by name. Returns [] on error. */
export async function searchCourses(query: string): Promise<GolfCourseApiSearchResult[]> {
  if (!query.trim()) return [];

  const data = await apiFetch<{ courses: GolfCourseApiSearchResult[] }>(
    `/courses?course_name=${encodeURIComponent(query)}`
  );
  return data?.courses ?? [];
}

/** Get full course details by ID. Returns null on error. */
export async function getCourseDetails(id: number): Promise<GolfCourseApiCourse | null> {
  // API wraps response in { course: { ... } }
  const data = await apiFetch<{ course: GolfCourseApiCourse }>(`/courses/${id}`);
  return data?.course ?? null;
}
